import React from 'react';
import './GuestFilters.css';

const GuestFilters = ({ filters, onFilterChange }) => {
  const handleChange = (field, value) => {
    onFilterChange({ [field]: value });
  };

  return (
    <div className="guest-filters">
      <div className="filter-row">
        {/* Search */}
        <div className="filter-group">
          <label>البحث</label>
          <div className="search-input">
            <i className="bi bi-search"></i>
            <input
              type="text"
              placeholder="ابحث بالاسم أو البريد أو الهاتف..."
              value={filters.search}
              onChange={(e) => handleChange('search', e.target.value)}
              className="touch-input"
            />
          </div>
        </div>

        {/* Source Filter */}
        <div className="filter-group">
          <label>المصدر</label>
          <select
            value={filters.source}
            onChange={(e) => handleChange('source', e.target.value)}
            className="touch-select"
          >
            <option value="">الكل</option>
            <option value="direct">حجز مباشر</option>
            <option value="airbnb">Airbnb</option>
            <option value="booking">Booking.com</option>
            <option value="expedia">Expedia</option>
            <option value="ical">iCal</option>
            <option value="gathern">Gathern</option>
            <option value="almosafer">المسافر</option>
          </select>
        </div>

        {/* Min Bookings Filter */}
        <div className="filter-group">
          <label>الحد الأدنى للحجوزات</label>
          <select
            value={filters.minBookings}
            onChange={(e) => handleChange('minBookings', e.target.value)}
            className="touch-select"
          >
            <option value="">الكل</option>
            <option value="2">2+ حجوزات</option>
            <option value="5">5+ حجوزات</option>
            <option value="10">10+ حجوزات</option>
          </select>
        </div>

        {/* Sort By */}
        <div className="filter-group">
          <label>ترتيب حسب</label>
          <select
            value={filters.sortBy}
            onChange={(e) => handleChange('sortBy', e.target.value)}
            className="touch-select"
          >
            <option value="lastBookingDate">آخر حجز</option>
            <option value="totalBookings">عدد الحجوزات</option>
            <option value="totalRevenue">الإيرادات</option>
            <option value="name">الاسم</option>
            <option value="createdAt">تاريخ التسجيل</option>
          </select>
        </div>

        {/* Sort Order */}
        <div className="filter-group">
          <button
            className={`sort-order-btn touch-icon-btn ${filters.sortOrder === -1 ? 'active' : ''}`}
            onClick={() => handleChange('sortOrder', filters.sortOrder === -1 ? 1 : -1)}
            title={filters.sortOrder === -1 ? 'تنازلي' : 'تصاعدي'}
          >
            <i className={`bi bi-sort-${filters.sortOrder === -1 ? 'down' : 'up'}`}></i>
          </button>
        </div>
      </div>

      {/* Active Filters Summary */}
      {(filters.search || filters.source || filters.minBookings) && (
        <div className="active-filters">
          <span>الفلاتر النشطة:</span>
          {filters.search && (
            <span className="filter-tag">
              بحث: {filters.search}
              <i className="bi bi-x" onClick={() => handleChange('search', '')}></i>
            </span>
          )}
          {filters.source && (
            <span className="filter-tag">
              المصدر: {filters.source}
              <i className="bi bi-x" onClick={() => handleChange('source', '')}></i>
            </span>
          )}
          {filters.minBookings && (
            <span className="filter-tag">
              الحد الأدنى: {filters.minBookings}
              <i className="bi bi-x" onClick={() => handleChange('minBookings', '')}></i>
            </span>
          )}
          <button
            className="clear-filters-btn"
            onClick={() => onFilterChange({ search: '', source: '', minBookings: '' })}
          >
            مسح الكل
          </button>
        </div>
      )}
    </div>
  );
};

export default GuestFilters;
